// Shared by Axios instances and Vue. Never include headers, bodies or query strings.
let sender = null
let pending = 0
let minute = 0
let sent = 0
const recent = new Map()

export function setErrorSender(callback) { sender = callback }

export function reportClientError(kind, message, trace = '', location = '', requestId = '') {
  const bucket = Math.floor(Date.now() / 60000)
  if (minute !== bucket) { minute = bucket; sent = 0; recent.clear() }
  const key = `${kind}:${message}:${location}`
  if (!sender || pending >= 2 || sent >= 20 || recent.has(key)) return
  recent.set(key, true)
  sent += 1
  pending += 1
  Promise.resolve().then(() => sender({
    kind, message: String(message).slice(0, 2000), trace: String(trace).slice(0, 4000),
    location: String(location).split(/[?#]/)[0].slice(0, 300), request_id: requestId,
  })).catch(() => {}).finally(() => { pending -= 1 })
}

export function observeAxios(client) {
  client.interceptors.response.use(response => {
    if (!response.config.skipErrorMonitoring && response.data && ['failure', 'error'].includes(response.data.result)) {
      reportClientError('api', `Application failure (HTTP ${response.status})`, '', response.config.url,
        response.headers?.['x-request-id'] || '')
    }
    return response
  }, error => {
    const config = error.config || {}
    if (!config.skipErrorMonitoring && error.code !== 'ERR_CANCELED' && !error.__CANCEL__) {
      reportClientError('api', error.response ? `HTTP ${error.response.status}` : 'Network request failed', '', config.url || '',
        error.response?.headers?.['x-request-id'] || '')
    }
    return Promise.reject(error)
  })
  return client
}

export function installVueErrors(Vue) {
  const previous = Vue.config.errorHandler
  Vue.config.errorHandler = (error, vm, info) => {
    reportClientError('vue', error && error.message || String(error), error && error.stack || '', `${window.location.pathname} (${info})`)
    if (previous) previous(error, vm, info)
    else console.error(error)
  }
  window.addEventListener('error', event => {
    reportClientError('javascript', event.message || 'Resource load failed', event.error && event.error.stack || '', window.location.pathname)
  })
  window.addEventListener('unhandledrejection', event => {
    const reason = event.reason
    reportClientError('promise', reason && reason.message || String(reason), reason && reason.stack || '', window.location.pathname)
  })
}
